import { render, staticRenderFns } from "./RequestHistoryLogItem.vue?vue&type=template&id=87bcec3c&scoped=true&"
import script from "./RequestHistoryLogItem.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryLogItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestHistoryLogItem.vue?vue&type=style&index=0&id=87bcec3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bcec3c",
  null
  
)

component.options.__file = "RequestHistoryLogItem.vue"
export default component.exports